import React from 'react';

const HamburgerMenu = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12" {...props}>
    <path
      fillRule="evenodd"
      d="M17.007 12A.994.994 0 0 0 18 11c0-.552-.445-1-.993-1H.993A.994.994 0 0 0 0 11c0 .552.445 1 .993 1h16.014zm0-5A.994.994 0 0 0 18 6c0-.552-.445-1-.993-1H.993A.994.994 0 0 0 0 6c0 .552.445 1 .993 1h16.014zM0 1c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 18 1c0-.552-.445-1-.993-1H.993A.994.994 0 0 0 0 1z"
    />
  </svg>
);

export default HamburgerMenu;
